import React from "react";
import { formatTime } from "../../utils/formatters";

export function VariationRow({
  variation,
  isCurrentTrack,
  isPlaying,
  currentTime,
  duration,
  onPlay,
  onSeek,
  isSupportUser,
  isToggling,
  onToggle,
}) {
  const { url, name, status_id, tag, tagColor } = variation;
  const isProcessing = url === null;
  const isPaused = status_id === 3;

  return (
    <div>
      <div style={{ display:"flex", alignItems:"center", gap:10, padding:"6px 0" }}>

        {isProcessing ? (
          <div style={{ width:28, height:28, borderRadius:"50%", background:"#F0F0F0", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
            <span style={{ fontSize:10, color:"#B8B8B8" }}>⏳</span>
          </div>
        ) : (
          <button
            onClick={onPlay}
            title={isCurrentTrack && isPlaying ? "Pause" : "Play"}
            style={{
              width:28,
              height:28,
              borderRadius:"50%",
              background: isCurrentTrack && isPlaying ? "#F90091" : "#F0F0F0",
              color: isCurrentTrack && isPlaying ? "#fff" : "#626262",
              border:"none",
              cursor:"pointer",
              display:"flex",
              alignItems:"center",
              justifyContent:"center",
              fontSize:10,
              flexShrink:0,
              opacity: isPaused ? 0.5 : 1,
            }}
          >
            {isCurrentTrack && isPlaying ? "❚❚" : "▶"}
          </button>
        )}

        <span style={{
          flex:1,
          fontSize:12,
          color: isProcessing ? "#B8B8B8" : isPaused ? "#B8B8B8" : "#151515",
          minWidth:0,
          overflow:"hidden",
          textOverflow:"ellipsis",
          whiteSpace:"nowrap",
        }}>
          {isProcessing ? "Processing…" : name}
        </span>

        <span style={{
          fontSize:9,
          padding:"2px 7px",
          borderRadius:20,
          fontWeight:700,
          textTransform:"uppercase",
          letterSpacing:0.5,
          background: status_id === 1 ? "#FFE9F6" : "#F0F0F0",
          color: tagColor,
          flexShrink:0,
        }}>
          {tag}
        </span>

        {isSupportUser && (
          <div
            onClick={!isToggling ? onToggle : undefined}
            style={{ display:"flex", alignItems:"center", gap:6, cursor: isToggling ? "default" : "pointer", opacity: isToggling ? 0.5 : 1, flexShrink:0 }}
          >
            <div style={{ position:"relative", width:30, height:17, background: !isPaused ? "#F90091" : "#E2E2E2", borderRadius:9, transition:"background 0.2s" }}>
              <div style={{ position:"absolute", top:2, left: !isPaused ? 15 : 2, width:13, height:13, background:"#fff", borderRadius:"50%", transition:"left 0.2s" }} />
            </div>
          </div>
        )}
      </div>

      {isCurrentTrack && !isProcessing && (
        <div style={{ display:"flex", alignItems:"center", gap:8, paddingLeft:38, paddingBottom:4 }}>
          <input
            type="range"
            min={0}
            max={duration || 1}
            step={0.1}
            value={currentTime}
            onChange={e => onSeek(Number(e.target.value))}
            style={{ flex:1, accentColor:"#F90091", cursor:"pointer" }}
          />
          <span style={{ fontSize:10, color:"#7b7b7b", flexShrink:0, minWidth:60, textAlign:"right" }}>
            {formatTime(currentTime)} / {formatTime(duration || 0)}
          </span>
        </div>
      )}
    </div>
  );
}
